<main class="pb-0">
  <section
    class="py-5"
    style="
      background-image: url('assets/images/login-background.jpg');
      background-size: cover;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-stretch g-0">
        <div class="col-md-10 mx-auto col-lg-5 shadow">
          <ins-login></ins-login>
        </div>
      </div>
    </div>
  </section>
</main>
